export default {
  unlocked_plural: '{{count}} tarjousta on avattu',
  unlocked: '{{offer}}-tarjous on avattu',
  removed_one: '{{offer}}-tarjous on poistettu',
  removed_other: '{{count}} on poistettu',
};
